import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["renderHeader", "renderFooter", "supportTwYearFormat"],
    _excluded2 = ["t", "value", "slots", "locale", "onChange", "toggleYearFormat", "supportTwYearFormat", "disablePortal"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CalendarIcon } from "./chunk-HLF6VBAG.mjs"; // src/TwDatePicker/ButtonDatePicker.tsx

import { styled } from "@mui/material/styles";
import { PickersLayoutRoot, usePickerLayout } from "@mui/x-date-pickers";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { PickersLayoutContentWrapper, pickersLayoutClasses } from "@mui/x-date-pickers/PickersLayout";
import tMoment from "moment-taiwan";
import { useCallback, useEffect, useRef, useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { jsx, jsxs } from "react/jsx-runtime";
var CalendarIconWrapper = styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n"])));
var SwitchButton = styled("button")(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.spacing(0.35),
    margin: theme.spacing(0.65, 2),
    cursor: "pointer",
    color: theme.palette.grey.A700,
    fontSize: theme.typography.button.fontSize,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.grey.A100
    }
  };
});

var ButtonField = function ButtonField(_ref2) {
  var toggleOpen = _ref2.toggleOpen,
      disabled = _ref2.disabled,
      InputProps = _ref2.InputProps;
  return /* @__PURE__ */jsx(CalendarIconWrapper, {
    children: /* @__PURE__ */jsx(CalendarIcon, {
      ref: InputProps === null || InputProps === void 0 ? void 0 : InputProps.ref,
      onClick: disabled ? null : toggleOpen
    })
  });
};

function CustomLayout(_ref3) {
  var _ref3$renderHeader = _ref3.renderHeader,
      renderHeader = _ref3$renderHeader === void 0 ? function () {
    return null;
  } : _ref3$renderHeader,
      _ref3$renderFooter = _ref3.renderFooter,
      renderFooter = _ref3$renderFooter === void 0 ? function () {
    return null;
  } : _ref3$renderFooter,
      _ref3$supportTwYearFo = _ref3.supportTwYearFormat,
      supportTwYearFormat = _ref3$supportTwYearFo === void 0 ? false : _ref3$supportTwYearFo,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var _usePickerLayout = usePickerLayout(rest),
      toolbar = _usePickerLayout.toolbar,
      tabs = _usePickerLayout.tabs,
      content = _usePickerLayout.content,
      actionBar = _usePickerLayout.actionBar;

  return /* @__PURE__ */jsx(PickersLayoutRoot, {
    ownerState: rest,
    sx: {
      width: "100%"
    },
    children: /* @__PURE__ */jsxs(PickersLayoutContentWrapper, {
      className: pickersLayoutClasses.contentWrapper,
      children: [supportTwYearFormat && renderHeader(), content, renderFooter()]
    })
  });
}

var ButtonDatePicker = function ButtonDatePicker(_ref4) {
  var _ref4$t = _ref4.t,
      t = _ref4$t === void 0 ? function (key, defaultText) {
    return defaultText;
  } : _ref4$t,
      value = _ref4.value,
      slots = _ref4.slots,
      locale = _ref4.locale,
      onChange = _ref4.onChange,
      toggleYearFormat = _ref4.toggleYearFormat,
      supportTwYearFormat = _ref4.supportTwYearFormat,
      _ref4$disablePortal = _ref4.disablePortal,
      disablePortal = _ref4$disablePortal === void 0 ? true : _ref4$disablePortal,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var _useState2 = useState(tMoment(value)),
      date = _useState2[0],
      setDate = _useState2[1];

  useEffect(function () {
    setDate(tMoment(value));
  }, [value]);
  var ref = useRef(null);
  var toggleOpen = useCallback(function () {
    setOpen(function (prev) {
      return !prev;
    });
  }, []);
  var handleClickOutside = useCallback(function () {
    if (!disablePortal) {
      return;
    }

    setOpen(false);
  }, [disablePortal]);
  var handleChange = useCallback(function (value2, context) {
    onChange === null || onChange === void 0 ? void 0 : onChange(value2.toDate(), context);
  }, [onChange]);
  var backToToday = useCallback(function () {
    setDate(tMoment());
  }, []);
  useOnClickOutside(ref, handleClickOutside);
  return /* @__PURE__ */jsx("div", {
    ref: ref,
    children: /* @__PURE__ */jsx(DatePicker, _objectSpread(_objectSpread({
      minDate: tMoment("1912/1/1"),
      slots: _objectSpread({
        field: ButtonField,
        layout: CustomLayout
      }, slots),
      slotProps: {
        field: {
          toggleOpen: toggleOpen
        },
        popper: {
          disablePortal: disablePortal
        },
        layout: {
          toggleYearFormat: toggleYearFormat,
          backToToday: backToToday,
          supportTwYearFormat: supportTwYearFormat,
          renderFooter: function renderFooter() {
            return /* @__PURE__ */jsx(SwitchButton, {
              onClick: backToToday,
              sx: {
                borderTop: "1px solid lightgray"
              },
              children: t("common:backToToday", "\u8FD4\u56DE\u4ECA\u65E5\u65E5\u671F")
            });
          },
          renderHeader: function renderHeader() {
            return /* @__PURE__ */jsx(SwitchButton, {
              onClick: toggleYearFormat,
              sx: {
                borderBottom: "1px solid lightgray"
              },
              children: t("common:switchTwYearFormat", "\u5207\u63DB\u6C11\u570B/\u897F\u5143\u5E74")
            });
          }
        }
      },
      value: date,
      disableHighlightToday: true,
      reduceAnimations: true,
      closeOnSelect: false
    }, rest), {}, {
      onChange: handleChange,
      open: open,
      onClose: toggleOpen,
      onOpen: toggleOpen
    }))
  });
};

export { ButtonField, ButtonDatePicker };